import AnimationClip from '../AnimationClip';
import { Tween } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import Renderable from '../../../Component/Renderable';
import Armature from '../../../Prototype/Armature';
import { AwaitIterators, PlayAnimation, StartAnimationClip } from '../AnimationHelper';
import { DragonbonesDefault } from './DragonbonesDefault';
import { delay } from '../../../Utility/Task/TaskQueue';
import { PlaySound } from '../../Audio/AudioHelper';
import Game from '../../../Game';


export interface PetUnlockParams {
    armature: Armature;
    continueButton: GameObject;
    textBox: GameObject;
}

export class PetUnlock extends AnimationClip<PetUnlockParams> {
    private meowInterval: () => void;

    public *execute(gameObject: GameObject, meta?: PetUnlockParams): IterableIterator<number> {
        const scene = Game.scene.getActiveScene();
        StartAnimationClip(
            new DragonbonesDefault(meta.armature, {
                playTimes: 1,
            })
        );
        yield* delay(2000);
        PlaySound('pet-box-open');

        yield* delay(750);
        PlaySound('pet-meow');

        yield* delay(4250);
        PlaySound('pet-meow');

        this.meowInterval = Game.ticker.setInterval(() => {
            PlaySound('pet-meow');
        }, 8850);

        const continueButtonRenderable = meta.continueButton.getComponent(Renderable);
        continueButtonRenderable.visible = true;
        continueButtonRenderable.alpha = 0;
        const continueButtonAlphaTween: Tween = this.getTween(continueButtonRenderable);

        const textBoxRenderable = meta.textBox.getComponent(Renderable);
        textBoxRenderable.visible = true;
        textBoxRenderable.alpha = 0;
        const textBoxAlphaTween: Tween = this.getTween(textBoxRenderable);

        const animationIterators = [
            PlayAnimation(
                new DragonbonesDefault(meta.armature, {
                    animationName: 'idle',
                })
            ),
            this.startTween(continueButtonAlphaTween.to({ alpha: 1 }, 500)),
            this.startTween(textBoxAlphaTween.to({ alpha: 1 }, 500)),
        ];

        yield* AwaitIterators(animationIterators);
    }

    public destroy() {
        super.destroy();
        Game.ticker.clearInterval(this.meowInterval);
    }
}
